// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1UoiN","inner":"Footer_inner__2JAdG"};